import { axiosJwt } from '@/shared/auth/axiosJwt';

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_LICITACOES_PORT}${process.env.VUE_APP_API_PATH}/licitacoes`;
const apiUnidade = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_LICITACOES_PORT}${process.env.VUE_APP_API_PATH}/licitacoes/unidade`;
const apiUsuario = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_LICITACOES_PORT}${process.env.VUE_APP_API_PATH}/licitacoes/usuario`;
const apiDocumentos = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_LICITACOES_PORT}${process.env.VUE_APP_API_PATH}/licitacoes/solicitacoes/documentos`;

const formDataType = {
    headers: {
        'Content-Type': 'multipart/form-data',
    },
};

export default {
    obterTodasSolicitacoes(filtros) {
        return axiosJwt.get(`${api}/solicitacoes`, {
            params: {
                ...filtros,
            },
        });
    },

    obterSolicitacaoPorId(id) {
        return axiosJwt.get(`${api}/solicitacoes/${id}/solicitacao`);
    },

    inserir(data) {
        const formData = new FormData();
        formData.append('gestor', data.gestor);
        formData.append('responsavel', data.responsavel);
        formData.append('numeroMatricula', data.numeroMatricula);
        formData.append('codigoSeap', data.codigoSeap);
        formData.append('dataAprovacao', data.dataAprovacao);
        formData.append('dataEntrada', data.dataEntrada);
        formData.append('emailResponsavel', data.emailResponsavel);
        formData.append('evento', data.evento);
        formData.append('objetoSolicitacao', data.objetoSolicitacao);
        formData.append('observacao', data.observacao);
        formData.append('unidade', data.unidade);
        data.arquivos.forEach((arquivo) => {
            formData.append('anexos', arquivo);
        });

        return axiosJwt.post(`${api}/solicitacoes/inserir/`, formData, formDataType);
    },
    obterUsuarios() {
        return axiosJwt.get(`${apiUsuario}/usuarios`);
    },

    obterUsuariosFiltro() {
        return axiosJwt.get(`${apiUsuario}/usuariosfiltro`);
    },

    obterUnidades() {
        return axiosJwt.get(`${apiUnidade}/todasunidades`);
    },
    obterResponsaveis() {
        return axiosJwt.get(`${api}/solicitacoes/responsaveis`);
    },
    obterEtapasPrincipais() {
        return axiosJwt.get(`${api}/solicitacoes/etapasprincipais`);
    },
    obterStatusTipoLicitacao() {
        return axiosJwt.get(`${api}/solicitacoes/etapatipo`);
    },

    obterTimeLinePorSolicitacao(solicitacaoId) {
        return axiosJwt.get(`${api}/solicitacoes/etapas/${solicitacaoId}/timeline`);
    },

    aprovarTr(solicitacaoId, data) {
        const formData = new FormData();
        data.forEach((file) => {
            formData.append('anexos', file);
        });
        formData.append('idSolicitacao', solicitacaoId);
        return axiosJwt.post(`${api}/solicitacoes/licitacao/${solicitacaoId}/aprovarTr`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    reprovarTr(solicitacaoId, data) {
        const formData = new FormData();
        data.forEach((file) => {
            formData.append('anexos', file);
        });
        formData.append('idSolicitacao', solicitacaoId);
        return axiosJwt.post(`${api}/solicitacoes/licitacao/${solicitacaoId}/reprovarTr`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    avancarFaseValidacaoEditalLicitacao(solicitacaoId, novoStatus) {
        return axiosJwt.post(`${api}/solicitacoes/licitacao/${solicitacaoId}/avancarfasevalidacaoedital`, novoStatus);
    },

    finalizarEdital(solicitacaoId, finalizarEdital) {
        return axiosJwt.post(`${api}/solicitacoes/licitacao/${solicitacaoId}/reprovaredital`, finalizarEdital);
    },

    reprovarEdital(solicitacaoId, data) {
        const formData = new FormData();
        data.forEach((file) => {
            formData.append('anexos', file);
        });
        formData.append('idSolicitacao', solicitacaoId);
        return axiosJwt.post(`${api}/solicitacoes/licitacao/${solicitacaoId}/reprovaredital`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    publicarEdital(solicitacaoId, data) {
        const formData = new FormData();
        data.anexos.forEach((file) => {
            formData.append('anexos', file);
        });
        formData.append('observacao', data.observacao);
        return axiosJwt.post(`${api}/solicitacoes/${solicitacaoId}/publicarEdital`, formData, formDataType);
    },

    ElaborarEdital(solicitacaoId, data, observacao) {
        const formData = new FormData();
        data.forEach((file) => {
            formData.append('anexos', file);
        });
        formData.append('idSolicitacao', solicitacaoId);
        formData.append('observacao', observacao);
        return axiosJwt.post(`${api}/solicitacoes/licitacao/${solicitacaoId}/elaborarEditalLicitacao`, formData, formDataType);
    },

    obterObservacoes(solicitacaoId) {
        return axiosJwt.get(`${api}/solicitacoes/licitacao/${solicitacaoId}/observacoes`);
    },
    obterAnexos(solicitacaoId) {
        return axiosJwt.get(`${api}/solicitacoes/documentos/documentosporsolicitacao/${solicitacaoId}`);
    },

    obterAnexo(documentoId) {
        return axiosJwt.get(`${api}/solicitacoes/documentos/anexo/${documentoId}`, {
            responseType: 'blob',
        });
    },
    obterAnexosPorEtapaAnaliseTR(solicitacaoId) {
        return axiosJwt.get(`${apiDocumentos}/${solicitacaoId}/documentodeanalisetr`);
    },

    obterAnexosPorEtapaInstrucaoCotacao(solicitacaoId) {
        return axiosJwt.get(`${apiDocumentos}/${solicitacaoId}/documentodafaseinstrucao`);
    },

    obterAnexosPorEtapaElaborarEdital(solicitacaoId) {
        return axiosJwt.get(`${apiDocumentos}/${solicitacaoId}/documentodafaseelaboraredital`);
    },

    obterAnexosPorEtapaValidacaoEdital(solicitacaoId) {
        return axiosJwt.get(`${apiDocumentos}/${solicitacaoId}/documentodafasevalidacaoedital`);
    },

    obterAnexosPorEtapaPublicacaoEdital(solicitacaoId) {
        return axiosJwt.get(`${apiDocumentos}/${solicitacaoId}/documentodafasepublicacaoedital`);
    },

    obterAnexosPorEtapaRecursos(solicitacaoId) {
        return axiosJwt.get(`${apiDocumentos}/${solicitacaoId}/documentodarecursos`);
    },

    obterAnexosPorEtapaHomologacao(solicitacaoId) {
        return axiosJwt.get(`${apiDocumentos}/${solicitacaoId}/documentodafasehomologacao`);
    },

    obterAnexosPorEtapaClassificacao(solicitacaoId) {
        return axiosJwt.get(`${apiDocumentos}/${solicitacaoId}/documentodafaseclassificacao`);
    },
    obterAnexosPorEtalaSolicitacao(solicitacaoId) {
        return axiosJwt.get(`${apiDocumentos}/${solicitacaoId}/documentodafaseaguardandoclassificacao`);
    },

    obterTodosOsAnexosDaSolicitacao(solicitacaoId, statusAtivo) {
        return axiosJwt.get(`${apiDocumentos}/${solicitacaoId}/documetosDaSolicitacao?statusativo=${statusAtivo}`);
    },

    atualizarPosicoes(anexos) {
        return axiosJwt.put(`${apiDocumentos}/atualizar-posicoes`, anexos);
    },

    sessaoPublica(solicitacaoId, data) {
        const formData = new FormData();
        formData.append('Recursos', data.recursos);
        formData.append('Observacao', data.observacao);
        data.anexos.forEach((arquivo) => {
            formData.append('Anexos', arquivo);
        });
        return axiosJwt.post(`${api}/solicitacoes/${solicitacaoId}/sessaoPublica`, formData, formDataType);
    },

    solicitarParecer(solicitacaoId, data) {
        const formData = new FormData();
        formData.append('observacao', data.observacao);
        data.anexos.forEach((arquivo) => {
            formData.append('anexos', arquivo);
        });
        return axiosJwt.post(`${api}/solicitacoes/${solicitacaoId}/solicitarParecer`, formData, formDataType);
    },

    IndeferirRecurso(solicitacaoId, data) {
        const formData = new FormData();
        data.anexos.forEach((file) => {
            formData.append('anexos', file);
        });
        formData.append('dataRazao', data.dataRazao);
        formData.append('dataContrarrazao', data.dataContrarrazao);
        formData.append('dataParecer', data.dataParecer);
        formData.append('observacao', data.observacao);
        return axiosJwt.post(`${api}/solicitacoes/${solicitacaoId}/recursos`, formData, formDataType);
    },

    DeferirRecurso(solicitacaoId, data) {
        const formData = new FormData();
        data.anexos.forEach((file) => {
            formData.append('anexos', file);
        });
        formData.append('dataRazao', data.dataRazao);
        formData.append('dataContrarrazao', data.dataContrarrazao);
        formData.append('dataParecer', data.dataParecer);
        formData.append('proximaEtapa', data.proximaEtapa);
        formData.append('observacao', data.observacao);
        return axiosJwt.post(`${api}/solicitacoes/${solicitacaoId}/recursos`, formData, formDataType);
    },

    obterAnexosPorEtapaAjustarTr(solicitacaoId) {
        return axiosJwt.get(`${apiDocumentos}/${solicitacaoId}/documentodafaseajustar`);
    },
    obterAnexosPorEtapaSecaoPublica(solicitacaoId) {
        return axiosJwt.get(`${apiDocumentos}/${solicitacaoId}/documentodafasesecaopublica`);
    },
    obterAnexosPorEtapaRecurso(solicitacaoId) {
        return axiosJwt.get(`${apiDocumentos}/${solicitacaoId}/documentodafaserecurso`);
    },
    reclassificar(solicitacaoId) {
        return axiosJwt.post(`${api}/solicitacoes/${solicitacaoId}/reclassificar`);
    },
    alterarStatusDocumento(anexoId, isDocumentoAtivo) {
        return axiosJwt.post(`${apiDocumentos}/${anexoId}/alterarstatus`, isDocumentoAtivo);
    },
};
